import { render, staticRenderFns } from "./CBackButton.vue?vue&type=template&id=7aff7078&"
import script from "./CBackButton.vue?vue&type=script&lang=js&"
export * from "./CBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports